import EocActiveMedicationsV1 from "../../../../components/form_builder/elements/eoc_active_medications/EocActiveMedicationsV1.vue";

export default {
  componentName: "fb-eoc-active-medications-v1",
  component: EocActiveMedicationsV1,
  defaultAttrs: {
    properties: {
      value: ``,
      style: {},
      label: "Active Medications",
      description: "",
      type: "both",
      hideAddButton: false,
      eFormEditable: true,
      hidden: false
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
